import {Typography} from "@mui/material";
import Button from "@mui/material/Button";
import {ResponsiveRow} from "../../../../constants/layout.constants";
import ViewApprovalModal from "../../../modals/dashboard/owner/viewApprovalModal";
import {useEffect, useState} from "react";
import {getHomeOwnerPendingApprovals} from "../../../../services/dashboard.service";
import MuiDataGrid from "../../MuiDataGrid";
import CapitalFundView from "../../../../pages/capitalFundView";
import {issueResponseMessage} from "../../../../actions/message";
import {approveCapitalFund} from "../../../../services/shared.service";

/**
 *
 * REQUIRED PROPS
 *
 *  customHeight: string
 *  customWidth: string
 *  data:{
 *      id: number
 *      type: string
 *      note: string
 *      date: string
 *      amount: string
 *      approvalDetails: {
 *        name: string
 *        startDate: string
 *        facility: string
 *        description: string
 *        endDate: string
 *        approvalRequired: string
 *        status: string
 *        approvalThreshold: string
 *        incomeAccount: string
 *        expensesAccount: string
 *        income:[]
 *        expenses:[]
 *      }
 *
 */

export default function HomeOwnerPendingApproval({
                                                     customHeight,
                                                     customWidth,
                                                 }) {
    const [dataGridRows, setDataGridRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [capitalFundModal, setCapitalFundModal] = useState(false);
    const [viewApprovalModal, setViewApprovalModal] = useState(false);
    const [viewApprovalData] = useState(null);    
    const [pendingItem, setPendingItem] = useState(null);

    function handleApproveAndReviewClick(data) {
        setPendingItem(data);
        setCapitalFundModal(true);
    }

    function handleApproveCapitalFund() {
        let data = pendingItem
        data.statusCd = "APP"
        setLoading(true);
             approveCapitalFund(data).then((response) => {
                    issueResponseMessage(response);
                    handleCapitalFundClose();
                    getHomeOwnerPendingApprovals()
            .then((response) => {
                if (response && response.data) {
                    setDataGridRows(response.data);
                }
            })
                }).finally(() => {
                    setLoading(false);
                });
    }

    function handleApproveRequest(data) {
    }

    function handleRejectCapitalFund() {
        let data = pendingItem
        data.statusCd = "REJ"
        setLoading(true);
             approveCapitalFund(data).then((response) => {
                    issueResponseMessage(response);
                    handleCapitalFundClose();
                    getHomeOwnerPendingApprovals()
            .then((response) => {
                if (response && response.data) {
                    setDataGridRows(response.data);
                }
            })
                }).finally(() => {
                    setLoading(false);
                });
    }

    function handleCapitalFundClose() {
        setPendingItem(null);
        setCapitalFundModal(false);
    }

    useEffect(() => {
        getHomeOwnerPendingApprovals()
            .then((response) => {
                if (response && response.data) {
                    setDataGridRows(response.data);
                }
            })
            .finally(() => {
                setLoading(false);
            });

        return () => {
            setDataGridRows([]);
        };
    }, []);

    const DataGridColumns = [
        {
            field: "type",
            headerName: "Type",
            width: 150,
        },
        {
            field: "description",
            headerName: "Description",
            minWidth: 150,
            flex: 2.5,
        },
        {
            field: "date",
            headerName: "Date",
            minWidth: 100,
            flex: 1,
        },
        {
            field: "status",
            headerName: "Status",
            minWidth: 100,
            flex: 1,
        },
        {
            field: "amount",
            headerName: "Amount",
            type: "number",
            minWidth: 100,
            flex: 1,
        },
        {
            field: "actions",
            minWidth: 70,
            flex: 0.7,
            headerName: "Actions",
            renderCell: (params) => {
                return (
                    <Button
                    variant="outlined"
                    size="medium"
                    onClick={() => {
                        handleApproveAndReviewClick(params.row);
                    }}
                >
                    Review
                </Button>                    
                );
            },
            width: 100,
        },
    ];

    return (
        <ResponsiveRow
            sx={{
                flexDirection: "column",
                flexWrap: "nowrap",
                alignItems: "flex-start",
                padding: "20px",
                height: {xs: "100%", lg: customHeight},
                width: {xs: "100%", lg: customWidth},
                marginBottom: "10px",
                backgroundColor: "#fff",
                borderRadius: "20px",
            }}
        >
            <Typography
                sx={{
                    width: "100%",
                }}
                textAlign="start"
                variant="h5"
            >
                Home Owners Pending Approvals
            </Typography>

            <MuiDataGrid
                alt={true}
                noSelection={true}
                dataGridColumns={DataGridColumns}
                dataGridRows={dataGridRows}
                serverPagination={false}
                loading={loading}
                height="90%"
                totalRows={dataGridRows.length}
            />

            <ViewApprovalModal
                handleAccept={handleApproveRequest}
                handleClose={() => setViewApprovalModal(false)}
                open={viewApprovalModal}
                data={viewApprovalData}
            />

            <CapitalFundView
                openModal={capitalFundModal}
                closeModal={handleCapitalFundClose}
                pendingItem={pendingItem}
                handleApproveCapitalFund={handleApproveCapitalFund}
                handleRejectCapitalFund={handleRejectCapitalFund}
            />
        </ResponsiveRow>
    );
}
